import React from "react";
import "./pages.css";
import SocialPosts from "../components/socialPostsLoop";
import SocialStories from "../components/socialStoriesLoop";

function Social({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Social Page</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main className="grundge1">
          <h1>Social</h1>
          <section className="socialSec">
            <SocialPosts deleteItem={deleteItem} user={user} />
            <SocialStories deleteItem={deleteItem} user={user} />
          </section>
        </main>
      </section>
    </>
  );
}

export default Social;
